import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
export const useScrollLock = () => {
  const $ = _c(6);
  const [scrollLockCount, setScrollLockCount] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = isLocked => {
      setScrollLockCount(prev => {
        const newCount = isLocked ? prev + 1 : Math.max(0, prev - 1);
        return newCount;
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setScrollLock = t0;
  let t1;
  let t2;
  if ($[1] !== scrollLockCount) {
    t1 = () => {
      const body = document.body;
      if (scrollLockCount > 0) {
        body.classList.add("overflow-hidden");
      }
      return () => {
        body.classList.remove("overflow-hidden");
      };
    };
    t2 = [scrollLockCount];
    $[1] = scrollLockCount;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(_temp, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      setScrollLock
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
function _temp() {
  const html = document.documentElement;
  html.classList.add("no-scrollbar");
  return () => {
    html.classList.remove("no-scrollbar");
  };
}